<template>
    <div class="md-testimionial comment-share">
        <!-- TODO:  Share only if the link address exists  -->
        <a
            v-if="facebookUrl"
            target="_blank"
            :href="facebookUrl"
            class="item iconfont icon-facebook-round"
            :aria-label="$t('md-testimonial.shareToFacebook')"
            rel="noopener noreferrer"
        ></a
        ><a
            v-if="linkedinUrl"
            target="_blank"
            :href="linkedinUrl"
            class="item iconfont icon-linkedin-round"
            :aria-label="$t('md-testimonial.shareToLinkedin')"
            rel="noopener noreferrer"
        ></a
        ><a
            v-if="twitterUrl"
            target="_blank"
            :href="twitterUrl"
            class="item iconfont icon-newtwitter-round"
            :aria-label="$t('md-testimonial.shareToTwitter')"
            rel="noopener noreferrer"
        ></a
        ><a
            v-if="gmailUrl"
            target="_blank"
            :href="gmailUrl"
            class="item iconfont icon-email-round"
            :aria-label="$t('md-testimonial.shareToGmail')"
            rel="noopener noreferrer"
        ></a>
    </div>
</template>

<script>
export default {
    name: 'coment-share',
    i18next: {
        ns: 'md-testimonial'
    },
    props: {
        facebookUrl: {
            type: String
        },
        linkedinUrl: {
            type: String
        },
        twitterUrl: {
            type: String
        },
        gmailUrl: {
            type: String
        }
    }
};
</script>

<style lang="scss">
$icons: (
    icon-facebook-round: #3b5998,
    icon-linkedin-round: #0e76a8,
    icon-newtwitter-round: #1da1f2,
    icon-email-round: #ef605d
);

.md-testimionial.comment-share {
    font-size: 24px;
    color: #c8c8c8;
    .item {
        padding-right: 12px;
        font-size: 20px;
        @each $key, $value in $icons {
            &.#{$key} {
                &:hover {
                    color: $value;
                }
            }
        }
    }
}
</style>
